var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(_vm.tag,{tag:"component",staticClass:"card mb-2",class:[
      _vm.$style.card,
      _vm.$style.borderRadius,
      _vm.contentNoBorder === 'true' ? _vm.$style.contentNoBorder : '',
      _vm.height === 'stretch' ? 'h-100' : '' ],style:([
      {
        border: _vm.border !== null ? _vm.border : '',
        boxShadow: _vm.boxShadow !== null ? _vm.boxShadow : '',
      },
      _vm.borderRadius,
      _vm.thisBorderColor,
      _vm.imageObjectFit,
      _vm.imageHeight !== null ? _vm.imageHeight : '' ]),on:{"click":function($event){return _vm.toSingle(_vm.url)}}},[(_vm.imgSrc !== null)?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.imgSrc),expression:"imgSrc"}],staticClass:"img-top",attrs:{"alt":_vm.title}}):_vm._e(),_c('div',{staticClass:"card-body"},[_vm._t("default")],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }